import createCalc from "components/Calculators/DSCRCalculator/utils/createCalc";
import updateCalc from "components/Calculators/DSCRCalculator/utils/updateCalc";
import * as gtag from "components/GTagManager";

const saveOrUpdate = async ({
  user,
  userProfile,
  answers,
  calc,
  calcType,
  setCalc,
  showUpdateFields,
  setShowCreatedSuccessMessage,
  setSnackbarData,
  isPDFGenerated = null,
  explanation = null,
  targetUserID = null,
  loanTermsUI = false,
  associatedLoanID = null,
}) => {
  let savedOrUpdated = "saved";
  const calcData = {}; // not used for escrow

  let updatedCalc;
  if (!calc) {
    updatedCalc = await createCalc(
      user,
      targetUserID ? targetUserID : userProfile.UID,
      answers,
      calcType,
      calcData,
      loanTermsUI ? 2 : 1, // emailType
      isPDFGenerated,
      explanation,
      associatedLoanID
    );

    // send an email to the user
    // with their calc details
    // so they have a way to return to it
    // this is done on the backend now, if query param l=1 is passed to createCalc
  } else {
    savedOrUpdated = "updated";
    const name = answers?.filter((answer) => {
      return answer?.q_title === "Calculation name";
    })?.[0]?.a_string;

    const address = answers?.filter((answer) => {
      return answer?.q_title === "Address (optional)";
    })?.[0]?.a_string;

    const data = {
      Answers: answers,
      CalcData: calcData,
      Name: name,
      Address: address,
    };

    if (isPDFGenerated !== null) {
      data["PDFGenerated"] = isPDFGenerated;
    }

    if (explanation !== null) {
      data["RichExplanation"] = explanation;
    }

    updatedCalc = await updateCalc(user, calc, data);
  }

  setCalc(updatedCalc);

  if (setShowCreatedSuccessMessage && !showUpdateFields && !loanTermsUI) {
    setShowCreatedSuccessMessage(true);
  }

  if (setSnackbarData && !isPDFGenerated) {
    // only show this if not concurently generating the pdf
    setSnackbarData({
      message: `Calculation ${savedOrUpdated}`,
      options: {
        variant: "success",
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      },
    });
  }

  gtag.event({ action: "escrow_calc-saved" });
  return updatedCalc;
};

export default saveOrUpdate;
